// Define your toastIds here
const TOAST_ID = {
    general: 'general',
    story: 'story-toast',
    storyOverview: 'story-overview-toast',
    pdpActionsToast: 'pdp-actions-toast',
    pdpActionsResponseToast: 'pdp-actions-response-toast',
    myListsActionsToast: 'my-lists-actions-toast',
    sharedCollectionToast: 'shared-collection-toast',
    myBooztOrderInfo: 'my-boozt-order-info',
    claimToastId: 'claim-toast-id',
    thankYouNPSRating: 'tyPage/nps-rating',
    checkoutPickupPointSelectorError: 'checkout/pickup-point-selector-error',
    checkoutBoxDeliverySelectorError: 'checkout/box-delivery-selector-error',
} as const;

export default TOAST_ID;
